<h1 class="text-xl font-medium mb-2">
  Neues Ticket
  <span *ngIf="ticketService.uploadPercent" class="text-green-500 text-xs"
    >( <fa-icon [icon]="longArrowUp"></fa-icon>
    {{ ticketService.uploadPercent | async }} )</span
  >
</h1>
<div class="new-ticket">
  <div class="bg-gray-200 py-4 relative">
    <input
      class="appearance-none w-full border-b border-transparent bg-transparent text-center font-medium uppercase block focus:outline-none focus:border-primary-500 px-4"
      type="text"
      [(ngModel)]="name"
    />
    <div class="new-ticket-dots"></div>
    <div class="px-4">
      <!-- select -->
      <div class="mb-3">
        <label class="block uppercase tracking-wide text-xs font-medium mb-2">
          Produktkategorie {{ uploadPercent | async }}
        </label>
        <div class="relative">
          <select
            class="block appearance-none w-full bg-white py-2 px-3 pr-8 leading-tight focus:outline-none focus:border-primary-500 transition-default"
            [(ngModel)]="category"
          >
            <option *ngFor="let c of categorys" [value]="c">{{ c }}</option>
          </select>
          <fa-icon [icon]="angleDown" class="absolute angle-select"></fa-icon>
        </div>
      </div>
      <!-- imgs -->
      <div class="mb-3">
        <label class="block uppercase tracking-wide text-xs font-medium mb-2">
          Bilder (max. 2)
        </label>
        <label class="file-select">
          <div
            class="bg-white py-2 px-4 text-center md:mb-0 cursor-pointer hover:bg-primary-500 focus:bg-primary-500 focus:outline-none focus:text-white hover:text-white transition-default"
          >
            <span
              >Bilder anhängen&nbsp;&nbsp;<fa-icon
                [icon]="cameraPolaroid"
              ></fa-icon
            ></span>
          </div>
          <input
            id="fileInput"
            #fileInput
            type="file"
            accept="image/*;capture=camera"
            class="hidden"
            multiple
            (change)="handleFileInput($event.target.files)"
          />
        </label>
        <div class="flex flex-col">
          <span *ngFor="let file of files" class="text-xs mt-2"
            ><fa-icon class="text-green-500" [icon]="fileCheck"></fa-icon>
            {{ file.name }}</span
          >
        </div>
      </div>
      <!-- address -->
      <div class="mb-3">
        <label class="block uppercase tracking-wide text-xs font-medium mb-2">
          Adresse
        </label>
        <input
          type="text"
          [(ngModel)]="address"
          placeholder="91555 Feuchtwangen, Walkmühlweg 18"
          class="block appearance-none w-full bg-white py-2 px-3 focus:outline-none focus:border-primary-500 transition-default placeholder-gray-400"
        >
      </div>
      <!-- description -->
      <div class="mb-3">
        <label class="block uppercase tracking-wide text-xs font-medium mb-2">
          Problem beschreiben
        </label>
        <textarea
          [(ngModel)]="description"
          rows="4"
          class="block appearance-none w-full bg-white py-2 px-3 focus:outline-none focus:border-primary-500 transition-default"
        ></textarea>
      </div>
    </div>
  </div>
  <button class="btn btn-primary w-full block" (click)="addTicket()">
    Ticket erstellen
  </button>
</div>
